module.exports = __webpack_public_path__ + "static/media/icon-place-3-turns.003772dc.svg";